import { createContext, useContext } from "react";
import { COMPONENT_SNAP_GAP } from "../../core/node-snapping";

export interface CanvasInteractionSettings {
  snapGap: number;
  defaultNodeRadius: number;
  noteSelectionTooltipEnabled: boolean;
}

const CanvasInteractionContext = createContext<CanvasInteractionSettings>({
  snapGap: COMPONENT_SNAP_GAP,
  defaultNodeRadius: 0,
  noteSelectionTooltipEnabled: true,
});

export const CanvasInteractionProvider = CanvasInteractionContext.Provider;

export function useCanvasInteractionSettings(): CanvasInteractionSettings {
  return useContext(CanvasInteractionContext);
}
